import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IKart, IKartTuru } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';

@Component({
  selector: 'dialog-sablon-secici',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, NzButtonModule, NzInputModule, NzIconModule, NzEmptyModule, NzTagModule, NzDividerModule],
  template: `
    <div class="py-dialog">
    <div style="display: flex;align-items: end;flex-direction:column;">
        <button nz-button
                (click)="nzModalRef.close()"
                style="position: absolute;"
                nzType="primary"
                nzDanger
                nzShape="circle"
                nzSize="small"><nz-icon nzType="close" />
        </button>
    </div>
    <div class="ui small header m-1">
        Şablondan Oluştur
    </div>

    <!-- Arama -->
    <div style="margin: 8px 0;">
        <nz-input-wrapper nzSize="small" [nzPrefix]="aramaIkon">
            <input nz-input placeholder="Şablon ara..." [(ngModel)]="aramaMetni" (ngModelChange)="filtrele()" nzSize="small" />
        </nz-input-wrapper>
        <ng-template #aramaIkon><nz-icon nzType="search" /></ng-template>
    </div>

    <!-- Yükleniyor -->
    @if (yukleniyor) {
        <div style="text-align: center; padding: 20px; color: var(--py-metin-ucuncul);">
            <i class="spinner loading icon"></i> Şablonlar yükleniyor...
        </div>
    }

    <!-- Şablonlarım -->
    @if (!yukleniyor && sablonlarim.length > 0) {
        <div style="font-size: 11px; font-weight: 600; color: var(--py-metin-ucuncul); margin: 8px 0 4px; text-transform: uppercase;">
            Şablonlarım
        </div>
        <div class="ui middle aligned divided selection list" style="max-height: 200px; overflow-y: auto;">
            @for (sablon of filtrelenmisKendi; track sablon._id) {
                <a class="item" (click)="sablonSec(sablon)" style="padding: 6px 8px;">
                    <div class="content" style="display: flex; align-items: center; gap: 8px;">
                        <span style="font-size: 18px;">{{ sablon.veri?.sablonSimge || '📋' }}</span>
                        <div>
                            <div class="header" style="font-size: 13px;">{{ sablon.veri?.sablonAdi || 'İsimsiz Şablon' }}</div>
                            <div class="description" style="font-size: 11px; color: var(--py-metin-ucuncul);">
                                {{ sablon.parametreler?.length ?? 0 }} parametre
                                @if (sablon.veri?.sablonAciklama) {
                                    · {{ sablon.veri.sablonAciklama }}
                                }
                            </div>
                        </div>
                    </div>
                </a>
            }
        </div>
    }

    <!-- Sistem Şablonları -->
    @if (!yukleniyor && sistemSablonlari.length > 0) {
        <nz-divider nzText="Sistem Şablonları" nzOrientation="left" style="margin: 8px 0;"></nz-divider>
        <div class="ui middle aligned divided selection list" style="max-height: 200px; overflow-y: auto;">
            @for (sablon of filtrelenmisSistem; track sablon._id) {
                <a class="item" [class.fiko-kilit]="sistemSablonKilit()" (click)="sablonSec(sablon)" style="padding: 6px 8px;">
                    <div class="content" style="display: flex; align-items: center; gap: 8px;">
                        <span style="font-size: 18px;">{{ sablon.veri?.sablonSimge || '📋' }}</span>
                        <div>
                            <div class="header" style="font-size: 13px;">{{ sablon.veri?.sablonAdi || 'İsimsiz Şablon' }}</div>
                            <div class="description" style="font-size: 11px; color: var(--py-metin-ucuncul);">
                                {{ sablon.parametreler?.length ?? 0 }} parametre
                                @if (sablon.veri?.sablonAciklama) {
                                    · {{ sablon.veri.sablonAciklama }}
                                }
                            </div>
                        </div>
                    </div>
                </a>
            }
        </div>
    }

    <!-- Boş durum -->
    @if (!yukleniyor && sablonlarim.length === 0 && sistemSablonlari.length === 0) {
        <nz-empty nzNotFoundContent="Henüz şablon yok" style="padding: 20px;"></nz-empty>
    }

    <div class="mt-3" style="display: flex;align-items: end;flex-direction:row;">
        <span style="flex: 1;"></span>
        <button nz-button nzSize="small" (click)="nzModalRef.close()">Kapat</button>
    </div>
    </div>
  `,
})
export class DialogSablonSeciciComponent extends FikoYTKokBilesenComponent implements OnInit {
  readonly nzModalRef = inject(NzModalRef);
  readonly data: any = inject(NZ_MODAL_DATA, { optional: true });

  sablonlarim: IKart<any>[] = [];
  sistemSablonlari: IKart<any>[] = [];
  filtrelenmisKendi: IKart<any>[] = [];
  filtrelenmisSistem: IKart<any>[] = [];
  aramaMetni = '';
  yukleniyor = false;

  constructor() {
    super();
  }

  async ngOnInit() {
    await this.sablonlariYukle();
  }

  async sablonlariYukle() {
    this.yukleniyor = true;
    this.CD.detectChanges();

    try {
      const kullaniciId = this.FikoYT.kimlik.aktifKullaniciJson()?._id;

      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.aggregate',
        parametreler: {
          aggregate: [
            {
              $match: {
                vt: "FikoYT.sistem.hareketler",
                turu: IKartTuru.SABLON,
                silindi: { $ne: true },
                $or: [
                  { sahip: kullaniciId },
                  { gizlilik: 'Herkese Açık' }
                ]
              }
            },
            { $sort: { tarih: -1 } },
            { $limit: 50 }
          ]
        },
        onEkOlsun: true,
        depoModu: false,
      });

      const cevap = await istek.isteSync();
      const tumSablonlar: IKart<any>[] = cevap?.cevap?.sonuc ?? [];

      this.sablonlarim = tumSablonlar.filter(s => s.sahip === kullaniciId);
      this.sistemSablonlari = tumSablonlar.filter(s => s.sahip !== kullaniciId);
      this.filtrele();
    } catch (e) {
      console.warn('Şablonlar yüklenemedi:', e);
    } finally {
      this.yukleniyor = false;
      this.CD.detectChanges();
    }
  }

  filtrele() {
    const metin = this.aramaMetni?.toLowerCase()?.trim();
    if (!metin) {
      this.filtrelenmisKendi = this.sablonlarim;
      this.filtrelenmisSistem = this.sistemSablonlari;
    } else {
      this.filtrelenmisKendi = this.sablonlarim.filter(s =>
        (s.veri?.sablonAdi || '').toLowerCase().includes(metin) ||
        (s.veri?.sablonAciklama || '').toLowerCase().includes(metin)
      );
      this.filtrelenmisSistem = this.sistemSablonlari.filter(s =>
        (s.veri?.sablonAdi || '').toLowerCase().includes(metin) ||
        (s.veri?.sablonAciklama || '').toLowerCase().includes(metin)
      );
    }
    this.CD.detectChanges();
  }

  /** 📢 premium özellik lisansı (köprü yoksa AÇIK). */
  lisans(alt: string): boolean { try { return (window as any).__fikoLisans?.('📢', alt) ?? true; } catch { return true; } }
  sistemSablonKilit(): boolean { return !this.lisans('sistem_sablon'); }

  sablonSec(sablon: IKart<any>) {
    // Başkasının (sistem) şablonu premium: sistem_sablon
    const sistemMi = this.sistemSablonlari.some(s => s._id === sablon._id);
    if (sistemMi && this.sistemSablonKilit()) { this.nzMessage?.warning('Sistem şablonları erişimi lisansınızda yok.'); return; }
    this.nzModalRef.close(sablon);
  }
}
